module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_int_03_6NV26_1SA_H2G.d5b24bfe.jpg";